<!-- 3d模型 -->
<template>
  <div id="three">

    <div style="background-color:#333;position: absolute;right:0;top:0;font-size: 20px;color:#fff;padding:5px 10px;" v-if="isConsole">x:{{c_x}},y:{{c_y}},z:{{c_z}}</div>

    <div style="position: absolute;right: 120px;top: 16px;z-index: 25;">
      <a-button type="primary" @click="toggleMaterial" size="small">
        切换材质
      </a-button>
    </div>

    <div id="chooseFrame" style="position: absolute;left: 10px;top: 10px;background-color: aliceblue;padding:5px;font-weight: bolder;">

    <a-checkbox @change="onChange" :checked="checkFrame">
      {{$t('components.outline')}}
    </a-checkbox>

    <a-checkbox @change="onToggleErrorData" :checked="checkErrorData" v-if="errorCode">
      {{$t('warehouseInfo.exceptionData')}}
    </a-checkbox>

    <a-button type="primary" size="small" @click="reset" style="margin-left: 10px;">
      {{$t('components.reset')}}
    </a-button>

    </div>

    <div class="heat-legend" v-if="heatLegendVisible && !hideLegend">
      <span class="heat-legend__label heat-legend__label--max">{{ heatLegendMax }}</span>
      <div class="heat-legend__bar"></div>
      <span class="heat-legend__label heat-legend__label--min">{{ heatLegendMin }}</span>
    </div>

  </div>
 
</template>


<script>
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {CSG} from "./three-csg.js"


var myCamera = null
var myScene = null

var container = null

var vector = new Three.Vector2();//三维坐标对象

var rayPoints = null


var raycaster = new Three.Raycaster();

var data_points= null
var data_index = null

var xzModel = null
var loadingFlag = false


var meshResult = null
var material111 = null
var gradientMaterial = null
var gradientMaterialGlobal = null  // Store gradient material reference for toggle
var coneMaterialGlobal = null  // Store cone material reference for toggle

var points = null
var errorAnomalies = null
var errorPoints = null


export default {
  name: "",
  props: ["datas","chang","kuan","gao","xiazhui","fcxzc","fcxzk","height","ckjg","lszl","isConsole","errorData","errorCode","hideLegend"],

  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      pointCloudGeometry:null,
      pointCloud:null,
      material:null,
      cPoints:null,
      //粮面高度(锥体上开始计算)
      grainHeight: 410,
      bottomHeight: 80,

      // 窗口尺寸变化
      screenWidth: null,
      timer: null,
      checkFrame:true,  // 默认显示外框
      checkHot:true,


      GLTFobjects:null,
      GLTFobjects0:null,
      myControl:null,
      flowLightMaterial: null,  // 流光效果材质引用，用于更新 time uniform
      flowClock: null,          // Three.Clock 实例
      scaleRuler: null,

      checkMesh:true,
      checkPoints:false,  // 默认不加载点云
      checkErrorData:true,

      useWheatTexture: false,  // 当前材质状态: false=条纹, true=小麦
      isTransitioning: false,  // 是否正在过渡

      //点坐标
      c_x:0,
      c_y:0,
      c_z:0,

      heatLegendVisible: false,
      heatLegendMax: '',
      heatLegendMin: ''
    };
  },
  methods: {

    onChange(e) {

      this.checkFrame = e.target.checked

      console.log(`checked = ${e.target.checked}`);

      this.GLTFobjects.visible = this.checkFrame;
      if(this.GLTFobjects0!=null){
        this.GLTFobjects0.visible = this.checkFrame;
      }
      if(this.barnModel!=null){
        this.barnModel.visible = this.checkFrame;
      }
      
    },

    //meshResult的显示与隐藏
    onToggleMesh(e){
      this.checkMesh = e.target.checked
      meshResult.visible = this.checkMesh
    },

    onTogglePoints(e){
      this.checkPoints = e.target.checked
      points.visible = this.checkPoints
    },

    onToggleErrorData(e){
      this.checkErrorData = e.target.checked
      if(errorAnomalies) {
        errorAnomalies.visible = this.checkErrorData
      }
      if(errorPoints) {
        errorPoints.visible = this.checkErrorData
      }
    },

    // 材质切换方法
    toggleMaterial() {
      // 防止重复触发过渡
      if (this.isTransitioning) return;
      
      this.isTransitioning = true;
      this.useWheatTexture = !this.useWheatTexture;
      
      // 确定过渡方向: 切换到小麦 = 自下而上 (1.0), 切换到条纹 = 自上而下 (-1.0)
      const direction = this.useWheatTexture ? 1.0 : -1.0;
      
      // 设置目标材质和方向 - gradientMaterial (粮面)
      if (gradientMaterialGlobal) {
        gradientMaterialGlobal.uniforms.useWheatMaterial.value = this.useWheatTexture ? 1.0 : 0.0;
        gradientMaterialGlobal.uniforms.transitionDirection.value = direction;
        gradientMaterialGlobal.uniforms.transitionProgress.value = 0.0;
      }
      
      // 设置目标材质和方向 - coneMaterial (下锥)
      if (coneMaterialGlobal) {
        coneMaterialGlobal.uniforms.useWheatMaterial.value = this.useWheatTexture ? 1.0 : 0.0;
        coneMaterialGlobal.uniforms.transitionDirection.value = direction;
        coneMaterialGlobal.uniforms.transitionProgress.value = 0.0;
      }
      
      // 动画参数
      const duration = 1500; // 1.5 秒
      const startTime = performance.now();
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1.0);
        
        // 缓动函数 (ease-in-out)
        const eased = progress < 0.5 
          ? 2 * progress * progress 
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        
        // 更新过渡进度 - gradientMaterial
        if (gradientMaterialGlobal) {
          gradientMaterialGlobal.uniforms.transitionProgress.value = eased;
        }
        
        // 更新过渡进度 - coneMaterial
        if (coneMaterialGlobal) {
          coneMaterialGlobal.uniforms.transitionProgress.value = eased;
        }
        
        if (progress < 1.0) {
          requestAnimationFrame(animate);
        } else {
          this.isTransitioning = false;
        }
      };
      
      requestAnimationFrame(animate);
    },

    onChangeHot(e) {

      this.checkHot = e.target.checked

      console.log(`checked = ${e.target.checked}`);

      if(this.checkHot){
        meshResult.material = gradientMaterial;
      }else{
        meshResult.material = material111;
      }

      },


    reset(){
      this.myControl.reset();
    },

    init() {
      // 使用组件根节点作为容器，避免多实例下 getElementById("three") 抓到错误节点
      container = this.$el;

      // 容器尺寸（保底 1，避免比例为 0/NaN）
      const _cw = (container && container.clientWidth) || 1;
      const _ch = (container && container.clientHeight) || 1;

      this.scene = myScene =  new Three.Scene();
      //this.scene.position(200,200,200)
      var directionalLight = new Three.DirectionalLight(0x333333, 0.5);
      directionalLight.name = "directionalLight";
      directionalLight.position.set(500, 800, 500);
      this.scene.add(directionalLight);

      var ambientLight = new Three.AmbientLight(0x333333, 0.2);
      ambientLight.name = "ambientLight";
      this.scene.add(ambientLight);

      var hemisphereLight = new Three.HemisphereLight(0x888888, 0x444444, 0.2);
      hemisphereLight.name = "hemisphereLight";
      this.scene.add(hemisphereLight);

      
      // 根据仓房实际尺寸自适应相机参数
      const _chang = Number(this.chang) || 50;
      const _kuan = Number(this.kuan) || 50;
      const _gao = Number(this.gao) || 20;
      const _xiazhui = Number(this.xiazhui) || 0;
      const _totalH = _gao + _xiazhui;
      const _maxDim = Math.max(_chang, _kuan, _totalH);
      // 视角中心点：仓房高度的中间
      const _target = new Three.Vector3(0, _totalH * 0.5, 0);
      // 初始距离：按最大尺寸放大 2.6 倍，确保所有仓型都能完整显示
      const _camDist = _maxDim * 2.6;

      this.camera = myCamera = new Three.PerspectiveCamera(
        45,
        _cw / _ch,                       // 使用容器比例，避免在窄列容器内被拉伸
        Math.max(0.1, _maxDim * 0.05),   // near
        _maxDim * 40                     // far
      );
      // 略带俯视角度，便于观察仓内结构
      this.camera.position.set(0, _camDist * 0.85, _camDist * 0.55);
      this.camera.lookAt(_target);
      this.scene.add(this.camera);

      this.renderer = new Three.WebGLRenderer({
        antialias: false,
        logarithmicDepthBuffer: true,
      });
      var control = new OrbitControls(this.camera, this.renderer.domElement);
      // 控制器视觉范围与仓房尺寸适配
      control.target.copy(_target);
      control.minDistance = _maxDim * 0.6;
      control.maxDistance = _maxDim * 8;
      control.update();

      var axes = new Three.AxesHelper(4000);
      axes.position.x = 0;
      axes.position.y = 0;
      axes.position.z = 0;
      //this.scene.add(axes);


      //this.renderer.setClearColor(0x223344);//0x999966
      this.renderer.setClearColor(0xffffff);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = Three.sRGBEncoding;
      this.renderer.physicallyCorrectLights = true;
      this.renderer.toneMapping = Three.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.5;
      this.renderer.setSize(_cw, _ch);

      // 监听容器尺寸变化，保持相机比例与渲染器尺寸一致
      this._setupResizeObserver(container);

      // 加载 HDR 环境贴图 (夜空)
      this.loadEnvironmentMap();

      // let geometry = new Three.CylinderBufferGeometry(0.2, 0.2, 0.2);

      // let material = new Three.MeshNormalMaterial();

      // this.mesh = new Three.Mesh(geometry, material);
      // 防止重复渲染
      if (container.children.length > 0) {
        //container.removeChild(container.children[0]);
      }
      container.appendChild(this.renderer.domElement);
      // 创建环绕场景的炫酷流光效果
      this.createFlowLightEffect();
      // 加载场景模型
      this.initContent();
      this.myControl = control
    },
    // 加载场景模型
    initContent() {

      let result = this.normalizePointData(this.datas)
      

      // 加载 glTF 格式的模型
     

      this.loadData(result)


      if(this.xiazhui == 0){
        
      }else{

      

      }

      
    },


         //选择一个物体
 onDocumentMouseDown( event ) {




vector.x = ((event.clientX - container.getBoundingClientRect().left) / container.offsetWidth) * 2 - 1
vector.y = -((event.clientY - container.getBoundingClientRect().top) / container.offsetHeight) * 2 + 1

raycaster.setFromCamera(vector,this.camera)

      const intersects = raycaster.intersectObjects(this.scene.children)

      if (intersects.length > 0) {
        var selected = intersects[0];//取第一个物体
        this.c_x = parseInt(selected.point.x)
        this.c_y = parseInt(selected.point.y)
        this.c_z = parseInt(selected.point.z)
        console.log("x坐标:" + selected.point.x);
        console.log("y坐标:" + selected.point.y);
        console.log("z坐标:" + selected.point.z);
        console.log(selected)
        //比较与所有点云的点的距离
        console.log("类型",typeof selected)
        console.log("index",selected.index)
        if(!!selected.index){
          data_index = selected.index

          console.log(data_points[data_index])

          let ptArr = data_points[data_index].split(",")

          this.c_x = ptArr[0]
          this.c_y = ptArr[1]
          this.c_z = ptArr[2]

        }
        
        if(!!rayPoints){
          this.scene.remove(rayPoints)
        }

        //创建一个立方体几何对象Geometry
        var geometry11 = new Three.BoxGeometry(4, 4, 4);
        //给几何体创建材质，这里是改为蓝色，材质对象Material
        var material11 = new Three.MeshLambertMaterial({
            color: 0x00ff00
        });
        //网格模型对象Mesh
        var mesh = new Three.Mesh(geometry11, material11);
        //mesh.position.set(selected.point.x-this.kuan/2, selected.point.y-this.gao, selected.point.z-this.chang/2  )
        mesh.position.set(selected.point.x, selected.point.y, selected.point.z  )
        //网格模型添加到场景中，每个模型最终都要添加到场景中才会被渲染
        rayPoints = mesh
        this.scene.add(rayPoints);

      }
 

},

    renderScene() {
      requestAnimationFrame(this.renderScene);
      // 更新流光效果的时间 uniform
      if (this.flowLightMaterial && this.flowClock) {
        this.flowLightMaterial.uniforms.time.value = this.flowClock.getElapsedTime();
      }
      this.renderer.render(this.scene, this.camera);
    },
    getTexture(png) {
      var texture = new Three.TextureLoader().load(png);
      return texture;
    },


    normalizePointData(data) {
      if (Array.isArray(data)) {
        return data.flat(Infinity).join(',');
      }
      if (typeof data === 'string') {
        return data;
      }
      if (data && typeof data === 'object') {
        const candidates = [
          data.pointData,
          data.data,
          data.points,
          data.total_points,
          data.point_data,
        ];
        for (let i = 0; i < candidates.length; i++) {
          const normalized = this.normalizePointData(candidates[i]);
          if (normalized && normalized.trim()) return normalized;
        }
      }
      return '';
    },

    loadData(data){

      let that = this
      data = this.normalizePointData(data);
      if (!data) {
        console.warn('squareModel loadData skipped: empty point data');
        return;
      }

     
      let loader = new GLTFLoader(); /*实例化加载器*/
      const geometry = new Three.BufferGeometry();

      const positions = [];
      const fillPositions = [];
      const colors = [];
      const fillColors = []

      const color = new Three.Color();

     
      let ptArr1 = data.split(",");
      let spArr = []
				let arrTmp = []
        let arr02 = null
				for(let i=0;i<=ptArr1.length-1;i=i+3){

					arrTmp.push(ptArr1[i]+","+ptArr1[i+1]+","+ptArr1[i+2])
				}

        arr02 = arrTmp
        data_points = arr02 
        let indexArr = []
				//let type = "平房仓"
				let type = "平方仓"

        let maxY = -Infinity;
            let minY = Infinity;
            
            for ( let i = 0; i < arr02.length-1; i ++ ) {
                let pt0 =  arr02[i].split(",");
                const x = (pt0[0]);
                let y = (pt0[2]);
                const z = ((pt0[1]));
                
                // 如果y小于等于0，将y值置为0.01
                if (y <= 0) {
                    y = 0.01;
                }
                if(y<0.01 && y>0){
                    y = 0.01;
                }

                // 点云高度包含了下锥高度，需要减去下锥高度得到实际粮面高度
                y = y - this.xiazhui;
                // 注意：y可以为负值（粮面在下锥区域内），不再强制为正
                
                const yFloat = parseFloat(y);  // 使用浮点值计算真实的 min/max

                const mirroredX = this.chang - x; 
                
                // Update max and min Y values (使用浮点值而非取整值)
                maxY = Math.max(maxY, yFloat);
                minY = Math.min(minY, yFloat);
                
                positions.push( mirroredX, y, z );
                indexArr.push(new Three.Vector3( mirroredX, yFloat, z ))
                // colors
                color.setRGB( 255, 204, 0 );
                colors.push( color.r, color.g, color.b );
            }
            
            // 沿仓墙对齐的边界点插入：避免 Delaunay 三角剖分不及仓墙，导致 CSG 裁剪后 meshResult 边缘与仓墙之间出现裂缝。
            // 边界点 Y 值通过 K-近邻距离倒数加权平均插值获得，与原始点云高度平滑衔接。
            // 使用负 inset 将边界点推到 CSG box 之外，确保 Delaunay 三角面完全穿透 CSG box 侧面，
            // 从而产生干净的裁剪边缘，消除粮面与仓壁之间的缝隙。
            (() => {
                if (indexArr.length === 0) return;
                const wallSamplesPerEdge = 20;
                const xMin = 0, xMax = this.chang;
                const zMin = 0, zMax = this.kuan;
                const inset = -Math.max(Math.min(this.chang, this.kuan) * 0.02, 3); // Negative inset: push boundary points BEYOND CSG box edges
                const sampleAt = (sx, sz) => {
                    const K = 4;
                    const dists = [];
                    for (let p = 0; p < indexArr.length; p++) {
                        const dx = indexArr[p].x - sx;
                        const dz = indexArr[p].z - sz;
                        dists.push({ d: Math.sqrt(dx * dx + dz * dz), y: indexArr[p].y });
                    }
                    dists.sort((a, b) => a.d - b.d);
                    const k = Math.min(K, dists.length);
                    let totalW = 0, totalY = 0;
                    for (let i = 0; i < k; i++) {
                        const w = 1 / (dists[i].d + 0.0001);
                        totalW += w;
                        totalY += dists[i].y * w;
                    }
                    return totalW > 0 ? totalY / totalW : 0;
                };
                const pushBoundary = (px, pz) => {
                    const py = sampleAt(px, pz);
                    indexArr.push(new Three.Vector3(px, py, pz));
                };
                // 4 个角点
                pushBoundary(xMin + inset, zMin + inset);
                pushBoundary(xMax - inset, zMin + inset);
                pushBoundary(xMax - inset, zMax - inset);
                pushBoundary(xMin + inset, zMax - inset);
                // 四条边均匀采样（不重复角点）
                for (let i = 1; i < wallSamplesPerEdge; i++) {
                    const t = i / wallSamplesPerEdge;
                    const x = xMin + (xMax - xMin) * t;
                    const z = zMin + (zMax - zMin) * t;
                    pushBoundary(x, zMin + inset);
                    pushBoundary(x, zMax - inset);
                    pushBoundary(xMin + inset, z);
                    pushBoundary(xMax - inset, z);
                }
            })();
            
            // 保存粮面真实最低点（浮点），用于颜色渐变归一化，
            // 让完整色谱覆盖真实高度范围，避免长宽远大于高度时所有颜色挤在暖色段
            const surfaceMinY = minY;
            // 向下取整并减1，确保边界正确（仅用于 belowMinColor 边界判定）
            minY = Math.floor(minY) - 1;
            
            console.log("最高点 (浮点):", maxY);
            console.log("最低点 (向下取整-1):", minY);
            console.log("粮面真实最低 (surfaceMinY):", surfaceMinY);
            this.heatLegendMax = this.formatMillimeterLabel(maxY);
            this.heatLegendMin = this.formatMillimeterLabel(surfaceMinY);
            this.heatLegendVisible = Number.isFinite(maxY) && Number.isFinite(surfaceMinY);
        
          console.log("點",positions)

          let showSize = 2.0;

				if(this.lszl == "玉米"){
					showSize = 5.0;
				}

				if(this.lszl == "小麦"){
					showSize = 2.0;
				}

				if(this.isConsole){
					showSize = 7.5;
				}

				// Set geometry attributes
				geometry.setAttribute('position', new Three.Float32BufferAttribute(positions, 3));
				geometry.setAttribute('color', new Three.Float32BufferAttribute(colors, 3));

				// Create texture loader and load point texture
				const textureLoader = new Three.TextureLoader();
				const pointTexture = textureLoader.load('/disc.png'); // Assuming point texture exists

				// Create custom shader material
				const shaderMaterial = new Three.ShaderMaterial({
					uniforms: {
						pointTexture: { value: pointTexture },
						pointSize: { value: showSize*10 },
						time: { value: 0 },
						maxY: { value: maxY }, // Add maxY uniform
						minY: { value: minY }, // Add minY uniform
						surfaceMinY: { value: surfaceMinY }, // 粮面真实最低（不含-1扩展）
						belowMinColor: { value: new Three.Color(0.0, 0.2, 0.8) }, // 深蓝色
						colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },    // 深蓝色
						colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },    // 浅蓝色
						colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },  // 中性灰色
						colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },    // 橙色
						colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) }     // 红色
					},
					
					vertexShader: `
						uniform float pointSize;
						uniform float maxY;
						uniform float minY;
						uniform float surfaceMinY;
						varying vec3 vColor;
						varying float vHeight;
						varying float vActualY;
						
						void main() {
							// 使用粮面真实范围归一化高度，让完整色谱覆盖真实高度变化
							vHeight = (position.y - surfaceMinY) / max(maxY - surfaceMinY, 0.0001);
							vActualY = position.y;
							vColor = color;
							vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
							gl_PointSize = pointSize * (300.0 / -mvPosition.z);
							gl_Position = projectionMatrix * mvPosition;
              gl_Position.y += 0.001;
						}
					`,
					fragmentShader: `
						uniform sampler2D pointTexture;
						uniform float minY;
						uniform vec3 belowMinColor;
						uniform vec3 colorCold1;
						uniform vec3 colorCold2;
						uniform vec3 colorNeutral;
						uniform vec3 colorWarm1;
						uniform vec3 colorWarm2;
						varying vec3 vColor;
						varying float vHeight;
						varying float vActualY;
						
						// 7段彩虹色阶：深蓝→蓝→青→绿→黄→橙→红，色谱更细腻
						vec3 getHeightColor(float t) {
							vec3 c0 = vec3(0.00, 0.15, 0.55);
							vec3 c1 = vec3(0.00, 0.45, 0.95);
							vec3 c2 = vec3(0.00, 0.85, 0.95);
							vec3 c3 = vec3(0.25, 0.85, 0.35);
							vec3 c4 = vec3(0.95, 0.95, 0.15);
							vec3 c5 = vec3(1.00, 0.55, 0.05);
							vec3 c6 = vec3(0.92, 0.12, 0.05);
							float seg = t * 6.0;
							if(seg < 1.0)      return mix(c0, c1, seg);
							else if(seg < 2.0) return mix(c1, c2, seg - 1.0);
							else if(seg < 3.0) return mix(c2, c3, seg - 2.0);
							else if(seg < 4.0) return mix(c3, c4, seg - 3.0);
							else if(seg < 5.0) return mix(c4, c5, seg - 4.0);
							else               return mix(c5, c6, seg - 5.0);
						}
						
						void main() {
							vec4 texColor = texture2D(pointTexture, gl_PointCoord);
							if(texColor.a < 0.5) discard;
							
							vec3 finalColor;
							
							// 如果点的实际Y坐标小于minY，使用 belowMinColor
							if(vActualY < minY) {
								finalColor = belowMinColor;
							} else {
								// surfaceMinY 到 maxY 之间使用7段彩虹渐变
								float t = clamp(vHeight, 0.0, 1.0);
								t = smoothstep(0.0, 1.0, t);
								finalColor = getHeightColor(t);
								
								// 等高线效果：每10%叠加暗带，强化局部高度差异感（类似地形图）
								float bandT = clamp(vHeight, 0.0, 1.0) * 10.0;
								float bandFract = abs(fract(bandT) - 0.5);
								float contour = smoothstep(0.42, 0.5, bandFract);
								finalColor *= mix(0.72, 1.0, contour);
							}
							
							float edge = smoothstep(0.4, 0.5, texColor.a);
							gl_FragColor = vec4(finalColor, edge);
						}
					`,
					transparent: true,
					vertexColors: true,
				});

				// Create points with custom shader material
				points = new Three.Points(geometry, shaderMaterial);
				points.frustumCulled = false;
				points.visible = this.checkPoints;  // 默认不显示点云
				this.scene.add(points);



				const axesHelper = new Three.AxesHelper(1000)
				//this.scene.add(axesHelper)


        //添加平面
        // triangulate x, z
				var indexDelaunay = Delaunator.from(
						indexArr.map(v => {
							return [v.x, v.z];
						})
				);

				console.log(indexDelaunay)

				var meshIndex = []; // delaunay index => three.js index
				for (let i = 0; i < indexDelaunay.triangles.length; i++){

					meshIndex.push(indexDelaunay.triangles[i]);
				}


				var geom = new Three.BufferGeometry().setFromPoints(indexArr);
				geom.setIndex(meshIndex); // add three.js index to the existing geometry
				geom.computeVertexNormals();
				var mesh0 = new Three.Mesh(
						geom, // re-use the existing geometry
						new Three.MeshBasicMaterial({ color: "#FF6600", wireframe: false, side: Three.DoubleSide })
				);

				//this.scene.add(mesh0);

        


				//添加立方体

				//长、框、高、下锥

				let w_height = this.gao*0.5;
				let w_length = this.kuan*0.5;
				let w_width = this.chang*0.5;
				let w_xiazhui = this.xiazhui*0.5;

        this.createScaleRuler(w_width, w_length, w_height, w_xiazhui);

        //this.scene.position.set(w_width, w_height*2, w_length)


				var warehouse = new Three.BoxGeometry(w_width, w_height, w_length);
				var material_w = new Three.MeshBasicMaterial({
					color: 0xfff
				});
				var cube = new Three.Mesh(warehouse, material_w);
				//scene.add(cube);

				// Create custom semi-transparent material for outline frames (无光照影响)
				const outlineFrameMaterial = new Three.ShaderMaterial({
					uniforms: {
						color: { value: new Three.Color(0.6, 0.55, 0.45) },
						opacity: { value: 0.0001 }  // 增加透明度 (降低 opacity)
					},
					vertexShader: `
						void main() {
							gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
						}
					`,
					fragmentShader: `
						uniform vec3 color;
						uniform float opacity;
						void main() {
							gl_FragColor = vec4(color, opacity);
						}
					`,
					transparent: true,
					depthWrite: false,
					depthTest: true,
					side: Three.DoubleSide,
					blending: Three.NormalBlending
				});

				// Create cone material for lower hopper (下锥) with wheat texture support
				// 完全参照 roundModel.vue 的实现
				const coneMaterial = new Three.ShaderMaterial({
					uniforms: {
						useWheatMaterial: { value: 0.0 },  // 0 = strip, 1 = wheat (procedural)
						transitionProgress: { value: 0.0 },  // 0-1 transition progress
						transitionDirection: { value: 1.0 }, // 1 = bottom-up, -1 = top-down
						modelMinY: { value: -500.0 },  // Model min Y bound
						modelMaxY: { value: 500.0 }    // Model max Y bound
					},
					vertexShader: `
						varying vec2 vUv;
						varying vec3 vPosition;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
						
						void main() {
							vPosition = position;
							vec4 worldPosition = modelMatrix * vec4(position, 1.0);
							vWorldPosition = worldPosition.xyz;
							vUv = vec2(worldPosition.x * 0.1, worldPosition.z * 0.1);
							vNormal = normalize(normalMatrix * normal);
							gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
						}
					`,
					fragmentShader: `
						uniform float useWheatMaterial;
						uniform float transitionProgress;
						uniform float transitionDirection;
						uniform float modelMinY;
						uniform float modelMaxY;
						varying vec2 vUv;
						varying vec3 vPosition;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
						
						// Hash function for randomness
						float hash(vec3 p) {
							p = fract(p * 0.3183099 + 0.1);
							p *= 17.0;
							return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
						}
						
						// 3D Noise function
						float noise(vec3 x) {
							vec3 i = floor(x);
							vec3 f = fract(x);
							f = f * f * (3.0 - 2.0 * f);
							
							return mix(mix(mix(hash(i + vec3(0,0,0)), hash(i + vec3(1,0,0)), f.x),
							               mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
							           mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x),
							               mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y), f.z);
						}
						
						// Fractal Brownian Motion for more detail
						float fbm(vec3 p) {
							float value = 0.0;
							float amplitude = 0.5;
							float frequency = 1.0;
							for(int i = 0; i < 4; i++) {
								value += amplitude * noise(p * frequency);
								amplitude *= 0.5;
								frequency *= 2.0;
							}
							return value;
						}
						
						// Voronoi-like pattern for wheat grains
						float wheatGrains(vec3 p, float scale) {
							p *= scale;
							vec3 i = floor(p);
							vec3 f = fract(p);
							
							float minDist = 1.0;
							vec3 minPoint = vec3(0.0);
							
							for(int x = -1; x <= 1; x++) {
								for(int y = -1; y <= 1; y++) {
									for(int z = -1; z <= 1; z++) {
										vec3 neighbor = vec3(float(x), float(y), float(z));
										vec3 cellPos = i + neighbor;
										
										vec3 randomOffset = vec3(
											hash(cellPos),
											hash(cellPos + vec3(31.0, 17.0, 23.0)),
											hash(cellPos + vec3(47.0, 53.0, 59.0))
										);
										
										vec3 grainPos = neighbor + randomOffset - f;
										vec3 grainScale = vec3(1.0, 0.4, 1.0);
										float dist = length(grainPos * grainScale);
										
										if(dist < minDist) {
											minDist = dist;
											minPoint = cellPos;
										}
									}
								}
							}
							
							return minDist;
						}
						
						// Generate wheat grain color
						vec3 getWheatColor(vec3 pos) {
							vec3 wheatLight = vec3(0.95, 0.85, 0.55);
							vec3 wheatMid = vec3(0.85, 0.70, 0.35);
							vec3 wheatDark = vec3(0.65, 0.50, 0.25);
							vec3 wheatShadow = vec3(0.45, 0.35, 0.20);
							
							float grainScale = 0.15;
							float grain = wheatGrains(pos, grainScale);
							float noiseVal = fbm(pos * grainScale * 2.0);
							
							float grainEdge = smoothstep(0.3, 0.5, grain);
							float grainCenter = 1.0 - smoothstep(0.0, 0.3, grain);
							float colorVar = hash(floor(pos * grainScale));
							
							vec3 grainColor = mix(wheatMid, wheatLight, grainCenter * 0.7);
							grainColor = mix(grainColor, wheatDark, grainEdge * 0.5);
							grainColor = mix(grainColor, wheatLight, colorVar * 0.3);
							grainColor = mix(grainColor, wheatDark, (1.0 - colorVar) * 0.2);
							grainColor *= 0.85 + noiseVal * 0.3;
							
							float groove = smoothstep(0.4, 0.5, grain);
							grainColor = mix(grainColor, wheatShadow, groove * 0.6);
							
							return grainColor;
						}
						
						void main() {
							// Get both material colors
							vec3 wheatColor = getWheatColor(vWorldPosition);
							vec3 stripColor = vec3(0.6, 0.6, 0.4); // 0x999966
							
							// Apply lighting
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							
							vec3 finalColor;
							
							// Check if transition is complete or not started
							if(transitionProgress <= 0.01) {
								// No transition - show current material directly
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor * diffuse;
								} else {
									finalColor = stripColor * diffuse;
								}
							} else if(transitionProgress >= 0.99) {
								// Transition complete - show target material
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor * diffuse;
								} else {
									finalColor = stripColor * diffuse;
								}
							} else {
								// During transition - blend based on height
								float heightRange = modelMaxY - modelMinY;
								float normalizedHeight = clamp((vWorldPosition.y - modelMinY) / heightRange, 0.0, 1.0);
								
								// Apply direction (1 = bottom-up, -1 = top-down)
								if(transitionDirection < 0.0) {
									normalizedHeight = 1.0 - normalizedHeight;
								}
								
								// Add noise to transition edge
								float edgeNoise = noise(vWorldPosition * 0.1) * 0.1;
								
								// Calculate transition threshold
								float transitionThreshold = transitionProgress * 1.2;
								float transitionEdge = smoothstep(transitionThreshold - 0.1 - edgeNoise, transitionThreshold + 0.05 + edgeNoise, normalizedHeight);
								
								// Blend factor based on target material
								float blendFactor;
								if(useWheatMaterial > 0.5) {
									// Transitioning TO wheat
									blendFactor = 1.0 - transitionEdge;
								} else {
									// Transitioning TO strip
									blendFactor = transitionEdge;
								}
								
								vec3 blendedColor = mix(stripColor, wheatColor, blendFactor);
								finalColor = blendedColor * diffuse;
							}
							
							gl_FragColor = vec4(finalColor, 1.0);
						}
					`,
					transparent: false,
					depthWrite: true,
					depthTest: true,
					side: Three.DoubleSide,
					polygonOffset: true,
					polygonOffsetFactor: 1,
					polygonOffsetUnits: 1
				});

				// Store global reference for material toggle
				coneMaterialGlobal = coneMaterial;

				//添加gltf
				// 外框扩大系数
				const frameScale = 1.03;

					if(w_xiazhui == 0){
						loader.load( '/hxc_model/cube_m.gltf', function ( gltf ) {

							gltf.scene.scale.set(w_width * frameScale, w_height * frameScale, w_length * frameScale)
							gltf.scene.traverse( function ( child ) {
								if ( child.isMesh ) {
									// Replace with custom semi-transparent material
									child.material = outlineFrameMaterial.clone();
									child.renderOrder = 10;  // Render after opaque objects
								}})

              that.scene.add( gltf.scene )
              that.GLTFobjects = gltf.scene
              gltf.scene.position.set(-w_width * frameScale, 0, -w_length * frameScale)
              gltf.scene.visible = that.checkFrame;  // Set initial visibility based on checkbox state
							//render();

						} );
					}else{

						loader.load( '/hxc_model/cube_m.gltf', function ( gltf ) {
							gltf.scene.scale.set(w_width * frameScale, w_height * frameScale, w_length * frameScale)
							gltf.scene.traverse( function ( child ) {
								if ( child.isMesh ) {
									child.material = outlineFrameMaterial.clone();
									child.renderOrder = 10;
								}})
							that.scene.add( gltf.scene );
              that.GLTFobjects = gltf.scene
              gltf.scene.position.set(-w_width * frameScale, 0, -w_length * frameScale)
              gltf.scene.visible = that.checkFrame;
						} );

            // 使用编程方式创建方仓下锥几何体（截锥体/棱台）
            // 上方棱柱形状与方仓长宽一致，下方棱柱形状使用下锥出口的长宽
            const fcxzcVal = that.fcxzc || w_width * 2 * 0.3;
            const fcxzkVal = that.fcxzk || w_length * 2 * 0.3;

            const frustumGeometry = that.createFrustumGeometry(
              w_width * 2,   // 上面宽度 = 方仓长(chang)
              w_length * 2,  // 上面深度 = 方仓宽(kuan)
              fcxzcVal,      // 下面宽度 = 下锥出口长度
              fcxzkVal,      // 下面深度 = 下锥出口宽度
              w_xiazhui * 2  // 下锥高度
            );

            // 创建下锥外框 mesh (使用半透明外框材质，与方仓外框一致)
            // 外框略大于填充体，避免 z-fighting，与方仓外框 frameScale 一致
            const frustumOutlineGeometry = that.createFrustumGeometry(
              w_width * 2 * frameScale,
              w_length * 2 * frameScale,
              fcxzcVal * frameScale,
              fcxzkVal * frameScale,
              w_xiazhui * 2 * frameScale
            );
            const frustumOutlineMesh = new Three.Mesh(frustumOutlineGeometry, outlineFrameMaterial.clone());
            frustumOutlineMesh.renderOrder = 10;
            frustumOutlineMesh.position.set(0, -w_xiazhui * 2 * frameScale, 0);
            
            const frustumOutlineGroup = new Three.Group();
            frustumOutlineGroup.add(frustumOutlineMesh);
            that.scene.add(frustumOutlineGroup);
            that.GLTFobjects0 = frustumOutlineGroup;
            frustumOutlineGroup.visible = that.checkFrame;

            // 创建下锥填充 mesh (使用 coneMaterial，与方仓材质保持一致)
            const frustumFillMesh = new Three.Mesh(frustumGeometry, coneMaterial);
            // 顶部必须严格落在 Y=0。整体上移会让 Y=0 截面沿斜面内缩，反而在边缘露出背景缝隙。
            frustumFillMesh.position.set(0, -w_xiazhui * 2, 0);

            // Update coneMaterial uniforms for Y bounds
            coneMaterial.uniforms.modelMinY.value = -w_xiazhui * 2;
            coneMaterial.uniforms.modelMaxY.value = 0;

            const frustumFillGroup = new Three.Group();
            frustumFillGroup.add(frustumFillMesh);
            xzModel = frustumFillGroup;
            that.scene.add(xzModel);
            console.log('xzModel (programmatic frustum)', xzModel);
            loadingFlag = true;
					}

          if(!this.isConsole){
          //布尔运算
				// Create box geometry and mesh for CSG operation (方仓区域: Y >= 0)
				// Delaunay 边界点已经被推到仓外，CSG 裁剪盒必须使用真实仓体尺寸，避免 meshResult 外扩后与下方仓体错边。
				var geometry111 = new Three.BoxGeometry(w_width * 2, w_height * 2, w_length * 2);
				material111 = new Three.MeshBasicMaterial({color: 0xFF6600});
				var cube111 = new Three.Mesh(geometry111, material111);
				cube111.position.set(w_width, w_height, w_length);
				
				// Update matrices for CSG
				mesh0.updateMatrix();
				cube111.updateMatrix();
				
				// Perform CSG intersection
				let bspA = new CSG.fromMesh(mesh0);
				let bspB = new CSG.fromMesh(cube111);

				// 判断粮面是否延伸到下锥区域 (minY < 0)
				if (minY < 0 && w_xiazhui > 0) {
					// 粮面部分在下锥区域内，使用下锥截锥体进行CSG裁剪
					const fcxzcCSG = that.fcxzc || w_width * 2 * 0.3;
					const fcxzkCSG = that.fcxzk || w_length * 2 * 0.3;
					
					// 创建截锥体几何体，顶点坐标以position为参考的局部坐标
					// position将设为 (w_width, w_height-w_xiazhui, w_length)
					// 世界坐标 = position + 局部坐标
					// 截锥体世界Y范围: -xiazhui ~ 0 = -w_xiazhui*2 ~ 0
					// 局部Y = 世界Y - position.y = 世界Y - (w_height - w_xiazhui)
					// 上面(世界Y=0): 局部Y = -(w_height - w_xiazhui) = w_xiazhui - w_height
					// 下面(世界Y=-w_xiazhui*2): 局部Y = -w_xiazhui*2 - (w_height - w_xiazhui) = -(w_height + w_xiazhui)
					const posY = w_height - w_xiazhui;
					const frustumLocalTopY = -posY;  // = w_xiazhui - w_height
					const frustumLocalBottomY = -(w_height + w_xiazhui);
					
					const hw1 = w_width, hd1 = w_length;  // 上面 = 方仓半长半宽
					const hw2 = fcxzcCSG / 2, hd2 = fcxzkCSG / 2;  // 下面 = 出口半长半宽
					
					const frustumVerts = new Float32Array([
						// 上面 (世界Y=0, 方仓底部, 与方仓长宽一致)
						-hw1, frustumLocalTopY, -hd1,
						 hw1, frustumLocalTopY, -hd1,
						 hw1, frustumLocalTopY,  hd1,
						-hw1, frustumLocalTopY,  hd1,
						// 下面 (世界Y=-xiazhui, 下锥出口尺寸)
						-hw2, frustumLocalBottomY, -hd2,
						 hw2, frustumLocalBottomY, -hd2,
						 hw2, frustumLocalBottomY,  hd2,
						-hw2, frustumLocalBottomY,  hd2,
					]);
					const frustumIdx = [
						0, 4, 1,  1, 4, 5,
						2, 6, 3,  3, 6, 7,
						1, 5, 2,  2, 5, 6,
						3, 7, 0,  0, 7, 4,
						0, 1, 2,  0, 2, 3,
						4, 6, 5,  4, 7, 6,
					];
					const csgFrustumGeom = new Three.BufferGeometry();
					csgFrustumGeom.setAttribute('position', new Three.BufferAttribute(frustumVerts, 3));
					csgFrustumGeom.setIndex(frustumIdx);
					csgFrustumGeom.computeVertexNormals();
					
					var csgFrustumMesh = new Three.Mesh(csgFrustumGeom, material111);
					csgFrustumMesh.position.set(w_width, posY, w_length);
					csgFrustumMesh.updateMatrix();

					let bspFrustum = new CSG.fromMesh(csgFrustumMesh);
					let bspResult = bspA.intersect(bspFrustum);
					meshResult = CSG.toMesh(bspResult, csgFrustumMesh.matrix, material111);
					// position设为(0, posY, 0)使XZ居中于0（与下锥外框对齐）
					meshResult.position.set(0, posY, 0);

					// 粮面在下锥区域内，隐藏下锥填充体
					if (xzModel) {
						xzModel.visible = false;
					}
				} else {
					// 粮面全部在方仓区域内，使用原有的box裁剪
					let bspResult = bspA.intersect(bspB);
					meshResult = CSG.toMesh(bspResult, bspB.matrix, bspB.material);
				}

				// Calculate center point and dimensions of meshResult
				meshResult.geometry.computeBoundingBox();
				const center = new Three.Vector3();
				meshResult.geometry.boundingBox.getCenter(center);
				const size = new Three.Vector3();
				meshResult.geometry.boundingBox.getSize(size);
				const maxDimension = Math.max(size.x, size.y, size.z);

				// Create shader material with height-based gradient and wheat texture support
				// 完全参照 roundModel.vue 的实现
				gradientMaterial = new Three.ShaderMaterial({
					uniforms: {
						center: { value: center },
						maxHeight: { value: size.y },
						minY: { value: minY },
						maxY: { value: maxY },
						surfaceMinY: { value: surfaceMinY },
						useWheatMaterial: { value: 0.0 },  // 0 = strip/gradient, 1 = wheat
						transitionProgress: { value: 0.0 },  // 0-1 transition progress
						transitionDirection: { value: 1.0 }, // 1 = bottom-up, -1 = top-down
						modelMinY: { value: minY },
						modelMaxY: { value: maxY },
						colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },    // Deep blue
						colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },    // Light blue
						colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },  // Neutral gray
						colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },    // Orange
						colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) }     // Red
					},
					vertexShader: `
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
																	
						void main() {
							vPosition = position;
							vec4 worldPosition = modelMatrix * vec4(position, 1.0);
							vActualY = worldPosition.y;
							vWorldPosition = worldPosition.xyz;
							vUv = vec2(worldPosition.x * 0.1, worldPosition.z * 0.1);
							vNormal = normalize(normalMatrix * normal);
							gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
						}
					`,
					fragmentShader: `
						uniform vec3 center;
						uniform float maxHeight;
						uniform float minY;
						uniform float maxY;
						uniform float surfaceMinY;
						uniform float useWheatMaterial;
						uniform float transitionProgress;
						uniform float transitionDirection;
						uniform float modelMinY;
						uniform float modelMaxY;
						uniform vec3 colorCold1;
						uniform vec3 colorCold2;
						uniform vec3 colorNeutral;
						uniform vec3 colorWarm1;
						uniform vec3 colorWarm2;
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
						
						// Hash function for randomness
						float hash(vec3 p) {
							p = fract(p * 0.3183099 + 0.1);
							p *= 17.0;
							return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
						}
						
						// 3D Noise function
						float noise(vec3 x) {
							vec3 i = floor(x);
							vec3 f = fract(x);
							f = f * f * (3.0 - 2.0 * f);
							
							return mix(mix(mix(hash(i + vec3(0,0,0)), hash(i + vec3(1,0,0)), f.x),
							               mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
							           mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x),
							               mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y), f.z);
						}
						
						// Fractal Brownian Motion
						float fbm(vec3 p) {
							float value = 0.0;
							float amplitude = 0.5;
							float frequency = 1.0;
							for(int i = 0; i < 4; i++) {
								value += amplitude * noise(p * frequency);
								amplitude *= 0.5;
								frequency *= 2.0;
							}
							return value;
						}
						
						// Voronoi-like pattern for wheat grains
						float wheatGrains(vec3 p, float scale) {
							p *= scale;
							vec3 i = floor(p);
							vec3 f = fract(p);
							
							float minDist = 1.0;
							
							for(int x = -1; x <= 1; x++) {
								for(int y = -1; y <= 1; y++) {
									for(int z = -1; z <= 1; z++) {
										vec3 neighbor = vec3(float(x), float(y), float(z));
										vec3 cellPos = i + neighbor;
										
										vec3 randomOffset = vec3(
											hash(cellPos),
											hash(cellPos + vec3(31.0, 17.0, 23.0)),
											hash(cellPos + vec3(47.0, 53.0, 59.0))
										);
										
										vec3 grainPos = neighbor + randomOffset - f;
										vec3 grainScale = vec3(1.0, 0.4, 1.0);
										float dist = length(grainPos * grainScale);
										
										if(dist < minDist) {
											minDist = dist;
										}
									}
								}
							}
							
							return minDist;
						}
						
						// Generate wheat grain color
						vec3 getWheatColor(vec3 pos) {
							vec3 wheatLight = vec3(0.95, 0.85, 0.55);
							vec3 wheatMid = vec3(0.85, 0.70, 0.35);
							vec3 wheatDark = vec3(0.65, 0.50, 0.25);
							vec3 wheatShadow = vec3(0.45, 0.35, 0.20);
							
							float grainScale = 0.15;
							float grain = wheatGrains(pos, grainScale);
							float noiseVal = fbm(pos * grainScale * 2.0);
							
							float grainEdge = smoothstep(0.3, 0.5, grain);
							float grainCenter = 1.0 - smoothstep(0.0, 0.3, grain);
							float colorVar = hash(floor(pos * grainScale));
							
							vec3 grainColor = mix(wheatMid, wheatLight, grainCenter * 0.7);
							grainColor = mix(grainColor, wheatDark, grainEdge * 0.5);
							grainColor = mix(grainColor, wheatLight, colorVar * 0.3);
							grainColor = mix(grainColor, wheatDark, (1.0 - colorVar) * 0.2);
							grainColor *= 0.85 + noiseVal * 0.3;
							
							float groove = smoothstep(0.4, 0.5, grain);
							grainColor = mix(grainColor, wheatShadow, groove * 0.6);
							
							return grainColor;
						}
						
						// Get strip/gradient color
						vec3 getStripGradientColor() {
							vec3 resultColor;
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							
							// Base color for below minY: 使用程序化小麦材质代替 0x999966 纯色
							vec3 baseColor = getWheatColor(vWorldPosition);
							
							// Use smooth transition at minY boundary to avoid z-fighting artifacts
							float boundaryBlend = smoothstep(minY - 1.0, minY + 1.0, vActualY);
							
							// 使用 surfaceMinY（粮面真实最低点）归一化，让完整色谱覆盖真实高度范围
							// 解决长宽远大于高度时颜色全部挤在暖色段的问题
							float t = clamp((vActualY - surfaceMinY) / max(maxY - surfaceMinY, 0.0001), 0.0, 1.0);
							t = smoothstep(0.0, 1.0, t);
							
							// 7段彩虹色阶：深蓝→蓝→青→绿→黄→橙→红
							vec3 c0 = vec3(0.00, 0.15, 0.55);
							vec3 c1 = vec3(0.00, 0.45, 0.95);
							vec3 c2 = vec3(0.00, 0.85, 0.95);
							vec3 c3 = vec3(0.25, 0.85, 0.35);
							vec3 c4 = vec3(0.95, 0.95, 0.15);
							vec3 c5 = vec3(1.00, 0.55, 0.05);
							vec3 c6 = vec3(0.92, 0.12, 0.05);
							float seg = t * 6.0;
							vec3 gradientColor;
							if(seg < 1.0)      gradientColor = mix(c0, c1, seg);
							else if(seg < 2.0) gradientColor = mix(c1, c2, seg - 1.0);
							else if(seg < 3.0) gradientColor = mix(c2, c3, seg - 2.0);
							else if(seg < 4.0) gradientColor = mix(c3, c4, seg - 3.0);
							else if(seg < 5.0) gradientColor = mix(c4, c5, seg - 4.0);
							else               gradientColor = mix(c5, c6, seg - 5.0);
							
							// 等高线效果：每10%叠加暗带，强化高度差异感（类似地形图）
							float relHeight = clamp((vActualY - surfaceMinY) / max(maxY - surfaceMinY, 0.0001), 0.0, 1.0);
							float bandT = relHeight * 10.0;
							float bandFract = abs(fract(bandT) - 0.5);
							float contour = smoothstep(0.42, 0.5, bandFract);
							gradientColor *= mix(0.72, 1.0, contour);
							
							// Blend between base color and gradient color
							resultColor = mix(baseColor * diffuse, gradientColor, boundaryBlend);
							return resultColor;
						}
											
						void main() {
							vec3 finalColor;
							float finalOpacity = 1.0;
							
							// Get both material colors
							vec3 wheatColor = getWheatColor(vWorldPosition);
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							wheatColor *= diffuse;
							
							vec3 stripColor = getStripGradientColor();
							
							// Check if transition is complete or not started
							if(transitionProgress <= 0.01) {
								// No transition - show current material directly
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else if(transitionProgress >= 0.99) {
								// Transition complete - show target material
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else {
								// During transition - blend based on height
								float heightRange = modelMaxY - modelMinY;
								float normalizedHeight = clamp((vWorldPosition.y - modelMinY) / heightRange, 0.0, 1.0);
								
								// Apply direction (1 = bottom-up, -1 = top-down)
								if(transitionDirection < 0.0) {
									normalizedHeight = 1.0 - normalizedHeight;
								}
								
								// Add noise to transition edge
								float edgeNoise = noise(vWorldPosition * 0.1) * 0.1;
								
								// Calculate transition threshold
								float transitionThreshold = transitionProgress * 1.2;
								float transitionEdge = smoothstep(transitionThreshold - 0.1 - edgeNoise, transitionThreshold + 0.05 + edgeNoise, normalizedHeight);
								
								// Blend factor based on target material
								float blendFactor;
								if(useWheatMaterial > 0.5) {
									// Transitioning TO wheat
									blendFactor = 1.0 - transitionEdge;
								} else {
									// Transitioning TO strip
									blendFactor = transitionEdge;
								}
								
								finalColor = mix(stripColor, wheatColor, blendFactor);
							}
												
							gl_FragColor = vec4(finalColor, finalOpacity);
						}
					`,
					transparent: false,
					depthWrite: true,
					depthTest: true,
					polygonOffset: true,
					polygonOffsetFactor: -1,
					polygonOffsetUnits: -1
				});

				// Store global reference for material toggle
				gradientMaterialGlobal = gradientMaterial;

				meshResult.material = gradientMaterial;
				meshResult.renderOrder = 1;




        this.scene.add(meshResult)
        // 正常分支需要偏移position，下锥分支已在CSG处理中设置了正确的position
        if (minY >= 0 || w_xiazhui <= 0) {
          meshResult.position.set(-w_width, 0, -w_length)
        }

        }

        points.position.set(-w_width, 0, -w_length)

        // 加载 barn.glb 模型
        this.loadBarnModel();

        // 加载异常数据
        this.loadErrorData(w_width, w_length)



       
        


      
        

    },

    // 创建方仓+下锥合并几何体（上部长方体 + 下部截锥体），用于CSG裁剪
    // boxW: 方仓长, boxD: 方仓宽, boxH: 方仓高, coneH: 下锥高, coneBottomW: 出口长, coneBottomD: 出口宽
    // 几何体以XZ原点为中心，Y范围: -coneH ~ +boxH
    createBoxFrustumGeometry(boxW, boxD, boxH, coneH, coneBottomW, coneBottomD) {
      const hw = boxW / 2, hd = boxD / 2;
      const chw = coneBottomW / 2, chd = coneBottomD / 2;

      // 12个顶点:
      // 方仓顶部4个(y=boxH), 方仓底部/下锥顶部4个(y=0), 下锥底部4个(y=-coneH)
      const vertices = new Float32Array([
        // 方仓顶部 (y = boxH)
        -hw,  boxH, -hd,   // 0
         hw,  boxH, -hd,   // 1
         hw,  boxH,  hd,   // 2
        -hw,  boxH,  hd,   // 3
        // 方仓底部 = 下锥顶部 (y = 0)
        -hw,  0,    -hd,   // 4
         hw,  0,    -hd,   // 5
         hw,  0,     hd,   // 6
        -hw,  0,     hd,   // 7
        // 下锥底部 (y = -coneH)
        -chw, -coneH, -chd, // 8
         chw, -coneH, -chd, // 9
         chw, -coneH,  chd, // 10
        -chw, -coneH,  chd, // 11
      ]);

      const indices = [
        // === 方仓部分 (上部长方体) ===
        // 顶面
        0, 1, 2,  0, 2, 3,
        // 前面 (z = -hd)
        0, 4, 1,  1, 4, 5,
        // 后面 (z = +hd)
        2, 6, 3,  3, 6, 7,
        // 右面 (x = +hw)
        1, 5, 2,  2, 5, 6,
        // 左面 (x = -hw)
        3, 7, 0,  0, 7, 4,
        // (底面不需要，与下锥共享)

        // === 下锥部分 (截锥体) ===
        // 前面
        4, 8, 5,   5, 8, 9,
        // 后面
        6, 10, 7,  7, 10, 11,
        // 右面
        5, 9, 6,   6, 9, 10,
        // 左面
        7, 11, 4,  4, 11, 8,
        // 底面
        8, 10, 9,  8, 11, 10,
      ];

      const geometry = new Three.BufferGeometry();
      geometry.setAttribute('position', new Three.BufferAttribute(vertices, 3));
      geometry.setIndex(indices);
      geometry.computeVertexNormals();
      return geometry;
    },

    // 创建方仓下锥几何体（截锥体/棱台）
    // topW: 上面宽度, topD: 上面深度, bottomW: 下面宽度, bottomD: 下面深度, h: 高度
    createFrustumGeometry(topW, topD, bottomW, bottomD, h) {
      const hw1 = topW / 2, hd1 = topD / 2;       // 上面半宽、半深
      const hw2 = bottomW / 2, hd2 = bottomD / 2;  // 下面半宽、半深

      // 8个顶点: 上面4个(y=h), 下面4个(y=0)
      // 顶点顺序: 上面(左前, 右前, 右后, 左后), 下面(左前, 右前, 右后, 左后)
      const vertices = new Float32Array([
        // 上面 (y = h) - 与方仓长宽一致
        -hw1, h, -hd1,  // 0: 左前
         hw1, h, -hd1,  // 1: 右前
         hw1, h,  hd1,  // 2: 右后
        -hw1, h,  hd1,  // 3: 左后
        // 下面 (y = 0) - 下锥出口尺寸
        -hw2, 0, -hd2,  // 4: 左前
         hw2, 0, -hd2,  // 5: 右前
         hw2, 0,  hd2,  // 6: 右后
        -hw2, 0,  hd2,  // 7: 左后
      ]);

      // 三角面索引 (6个面, 每面2个三角形)
      const indices = [
        // 前面 (z = -hd)
        0, 4, 1,  1, 4, 5,
        // 后面 (z = +hd)
        2, 6, 3,  3, 6, 7,
        // 右面 (x = +hw)
        1, 5, 2,  2, 5, 6,
        // 左面 (x = -hw)
        3, 7, 0,  0, 7, 4,
        // 上面 (y = h)
        0, 1, 2,  0, 2, 3,
        // 下面 (y = 0)
        4, 6, 5,  4, 7, 6,
      ];

      const geometry = new Three.BufferGeometry();
      geometry.setAttribute('position', new Three.BufferAttribute(vertices, 3));
      geometry.setIndex(indices);
      geometry.computeVertexNormals();

      return geometry;
    },

    formatMillimeterLabel(value) {
      // 图例刻度值：与轴刷一致（除以 100，保留小数后 2 位）
      const num = Number(value);
      if (!Number.isFinite(num)) return '';
      return (num / 100).toFixed(2);
    },

    formatRulerLabel(value) {
      // 先取整数刻度值，再转换为米并保留小数后两位（原数值需乘以10后再除以1000，等价于除以100）
      const num = Math.round(Number(value) || 0);
      return (num / 100).toFixed(2);
    },

    createLine(points, color = 0x444444, opacity = 0.85) {
      const geometry = new Three.BufferGeometry().setFromPoints(points);
      const material = new Three.LineBasicMaterial({
        color,
        transparent: true,
        opacity,
        depthTest: false,
      });
      const line = new Three.Line(geometry, material);
      line.renderOrder = 30;
      return line;
    },

    createTextSprite(text, size, color = '#555555') {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const fontSize = 42;
      context.font = `${fontSize}px Arial`;
      const textWidth = Math.ceil(context.measureText(text).width);
      canvas.width = Math.max(96, textWidth + 28);
      canvas.height = 72;

      context.font = `${fontSize}px Arial`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = color;
      context.fillText(text, canvas.width / 2, canvas.height / 2);

      const texture = new Three.Texture(canvas);
      texture.needsUpdate = true;
      const material = new Three.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false,
      });
      const sprite = new Three.Sprite(material);
      const ratio = canvas.width / canvas.height;
      sprite.scale.set(size * ratio, size, 1);
      sprite.renderOrder = 31;
      return sprite;
    },

    createScaleRuler(w_width, w_length, w_height, w_xiazhui) {
      if (!this.scene) return;
      if (this.scaleRuler) {
        this.scene.remove(this.scaleRuler);
      }

      const width = Number(w_width) * 2 || 0;
      const depth = Number(w_length) * 2 || 0;
      const boxHeight = Number(w_height) * 2 || 0;
      const coneHeight = Number(w_xiazhui) * 2 || 0;
      const totalHeight = boxHeight + coneHeight;
      const maxDim = Math.max(width, depth, totalHeight, 1);
      const tickSize = maxDim * 0.025;
      // 刻度文字字号减半
      const labelSize = maxDim * 0.03;
      const group = new Three.Group();
      group.name = 'scaleRuler';

      const xStart = -w_width;
      const xEnd = w_width;
      const zStart = -w_length;
      const zEnd = w_length;
      const yStart = -coneHeight;
      const yEnd = boxHeight;
      const xAxisZ = zStart;
      const zAxisX = xStart;
      const verticalX = xStart;
      const verticalZ = zStart;
      const baseY = yStart;
      // 内部尺寸单位换算到米为 /100，因此 5m 对应 500。
      const tickStep = 500;
      const origin = new Three.Vector3(xStart, baseY, zStart);

      group.add(this.createLine([
        origin,
        new Three.Vector3(xEnd, baseY, xAxisZ),
      ]));
      group.add(this.createLine([
        origin,
        new Three.Vector3(zAxisX, baseY, zEnd),
      ]));
      group.add(this.createLine([
        origin,
        new Three.Vector3(verticalX, yEnd, verticalZ),
      ]));

      for (let value = 0; value <= width; value += tickStep) {
        const x = xStart + value;
        group.add(this.createLine([
          new Three.Vector3(x, baseY, xAxisZ - tickSize * 0.45),
          new Three.Vector3(x, baseY, xAxisZ + tickSize * 0.45),
        ]));
        const xLabel = this.createTextSprite(this.formatRulerLabel(value), labelSize);
        xLabel.position.set(x, baseY - tickSize * 0.75, xAxisZ - tickSize * 1.25);
        group.add(xLabel);
      }

      for (let value = 0; value <= depth; value += tickStep) {
        const z = zStart + value;
        group.add(this.createLine([
          new Three.Vector3(zAxisX - tickSize * 0.45, baseY, z),
          new Three.Vector3(zAxisX + tickSize * 0.45, baseY, z),
        ]));
        const zLabel = this.createTextSprite(this.formatRulerLabel(value), labelSize);
        zLabel.position.set(zAxisX - tickSize * 1.5, baseY - tickSize * 0.45, z);
        group.add(zLabel);
      }

      for (let value = 0; value <= totalHeight; value += tickStep) {
        const y = yStart + value;
        group.add(this.createLine([
          new Three.Vector3(verticalX - tickSize * 0.45, y, verticalZ),
          new Three.Vector3(verticalX + tickSize * 0.45, y, verticalZ),
        ]));
        const yLabel = this.createTextSprite(this.formatRulerLabel(value), labelSize);
        yLabel.position.set(verticalX - tickSize * 1.9, y, verticalZ);
        group.add(yLabel);
      }

      const xName = this.createTextSprite('X', labelSize * 1.2, '#444444');
      xName.position.set(xEnd + tickSize * 1.6, baseY, xAxisZ - tickSize * 0.3);
      group.add(xName);

      const yName = this.createTextSprite('Y', labelSize * 1.2, '#444444');
      yName.position.set(zAxisX - tickSize * 1.6, baseY, zEnd + tickSize * 0.8);
      group.add(yName);

      const zName = this.createTextSprite('Z', labelSize * 1.2, '#444444');
      zName.position.set(verticalX - tickSize * 1.2, yEnd + tickSize * 1.4, verticalZ);
      group.add(zName);

      this.scaleRuler = group;
      this.scene.add(group);
    },

    // 加载 HDR 环境贴图（夜空），并设置为场景背景和环境光照
    loadEnvironmentMap() {
      const that = this;
      const textureLoader = new Three.TextureLoader();
      textureLoader.load(
        '/hxc_model/NightSkyHDRI001_2K/NightSkyHDRI003_8K_TONEMAPPED.jpg',
        function (texture) {
          // 等矩矩形映射 (球形全景)
          texture.mapping = Three.EquirectangularReflectionMapping;
          texture.colorSpace = Three.SRGBColorSpace || Three.sRGBEncoding;

          // 使用 PMREMGenerator 生成环境反射贴图
          const pmrem = new Three.PMREMGenerator(that.renderer);
          pmrem.compileEquirectangularShader();
          const envMap = pmrem.fromEquirectangular(texture).texture;

          that.scene.background = texture;  // 直接用原始贴图作为背景
          that.scene.environment = envMap;  // PMREM 用于 PBR 材质反射

          texture.dispose();
          pmrem.dispose();
          console.log('HDR environment map loaded');
        },
        undefined,
        function (err) {
          console.error('Failed to load environment map:', err);
        }
      );
    },

    // 创建环绕场景的炫酷流光效果
    // 包含：动态网格、向外扩散的能量环、旋转扫描光束、炫彩极光色相差
    createFlowLightEffect() {
      const that = this;
      // 地面尺寸：以仓房最大边长的 8 倍作为流光效果覆盖范围
      const baseSize = Math.max(this.chang, this.kuan) * 8;

      const flowGeometry = new Three.PlaneGeometry(baseSize, baseSize, 1, 1);

      const flowMaterial = new Three.ShaderMaterial({
        uniforms: {
          time: { value: 0.0 },
          baseColor:  { value: new Three.Color(0x0a1a30) }, // 深蓝底色
          gridColor:  { value: new Three.Color(0x00ffff) }, // 青蓝网格
          pulseColor: { value: new Three.Color(0x0a3a8c) }  // 深邂科技蓝能量环
        },
        vertexShader: `
          varying vec2 vUv;
          varying vec3 vWorldPos;
          void main() {
            vUv = uv;
            vec4 worldPos = modelMatrix * vec4(position, 1.0);
            vWorldPos = worldPos.xyz;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
          }
        `,
        fragmentShader: `
          uniform float time;
          uniform vec3 baseColor;
          uniform vec3 gridColor;
          uniform vec3 pulseColor;
          varying vec2 vUv;
          varying vec3 vWorldPos;

          // 混淆函数
          float hash(vec2 p) {
            return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
          }

          float noise(vec2 p) {
            vec2 i = floor(p);
            vec2 f = fract(p);
            f = f * f * (3.0 - 2.0 * f);
            float a = hash(i);
            float b = hash(i + vec2(1.0, 0.0));
            float c = hash(i + vec2(0.0, 1.0));
            float d = hash(i + vec2(1.0, 1.0));
            return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
          }

          void main() {
            vec2 uv = vUv - 0.5;              // [-0.5, 0.5]
            float dist = length(uv);          // 到中心距离
            float ang  = atan(uv.y, uv.x);    // 极角度

            vec3 color = baseColor;

            // 1) 动态网格：水平/垂直线
            vec2 gridUV = vUv * 40.0;
            vec2 gridAxis = abs(fract(gridUV - 0.5) - 0.5);
            float gridLine = 1.0 - smoothstep(0.0, 0.04, min(gridAxis.x, gridAxis.y));
            // 网格流动辉光
            float gridPulse = 0.5 + 0.5 * sin(time * 2.0 - dist * 20.0);
            color += gridColor * gridLine * (0.3 + gridPulse * 0.5) * smoothstep(0.5, 0.05, dist);

            // 2) 向外扩散的能量环 (多层 + 辉光效果)
            for (int i = 0; i < 3; i++) {
              float fi = float(i);
              float ringPhase = fract(time * 0.3 + fi * 0.33);
              float ringRadius = ringPhase * 0.7;
              float ringAlpha = (1.0 - ringPhase) * (1.0 - ringPhase);
              float ringWidth = 0.001;

              // 内核亮线
              float ringCore = smoothstep(ringWidth, 0.0, abs(dist - ringRadius));
              // 外层辉光（较宽，指数行轻柔衰减）
              float glowDist = abs(dist - ringRadius);
              float ringGlowWide = exp(-glowDist * 55.0);   // 中层辉光 (更窄)
              float ringGlowSoft = exp(-glowDist * 22.0);   // 外层流安 (更窄)

              // 深色基底 + 亮色高光 (点亮时偏青白，外圈偏深蓝)
              vec3 highlight = vec3(0.7, 0.9, 1.0);           // 冷白高光
              vec3 deepCore  = pulseColor * 1.4;              // 核心深蓝
              vec3 outerGlow = pulseColor * 0.8;              // 外圈更深

              color += highlight * ringCore * ringAlpha * 1.3;
              color += deepCore  * ringGlowWide * ringAlpha * 0.8;
              color += outerGlow * ringGlowSoft * ringAlpha * 0.4;
            }

            // 3) 已移除旋转扫描光束

            // 4) 背景噪点微粒子闪烁
            float twinkle = noise(vUv * 120.0 + time * 0.5);
            float sparkle = smoothstep(0.92, 1.0, twinkle) * (0.5 + 0.5 * sin(time * 8.0 + twinkle * 30.0));
            color += vec3(0.4, 0.7, 1.0) * sparkle * 0.8;

            // 5) 边缘淡出：远离中心渐隐
            float edgeFade = smoothstep(0.5, 0.15, dist);
            color *= edgeFade;

            // 中心圆盘在仓房下方隐藏（避免覆盖仓房底部）
            float centerMask = smoothstep(0.0, 0.08, dist);
            color *= centerMask;

            gl_FragColor = vec4(color, edgeFade * 0.95);
          }
        `,
        transparent: true,
        depthWrite: false,
        side: Three.DoubleSide,
        blending: Three.AdditiveBlending
      });

      const flowPlane = new Three.Mesh(flowGeometry, flowMaterial);
      flowPlane.rotation.x = -Math.PI / 2;   // 水平放置
      flowPlane.position.y = -this.xiazhui - 2; // 稍低于仓房底部
      flowPlane.renderOrder = -1;
      this.scene.add(flowPlane);

      // 同时更新背景色，增强流光对比度
      this.renderer.setClearColor(0x050810);

      this.flowLightMaterial = flowMaterial;
      this.flowClock = new Three.Clock();
    },

    // 加载 barn.glb 模型，按仓房长宽高比例缩放并添加到场景
    loadBarnModel() {
      let that = this;
      let loader = new GLTFLoader();

      loader.load('/hxc_model/barn.glb', function (gltf) {
        const model = gltf.scene;

        // 检查并打印模型材质信息
        const materialTypes = new Set();
        model.traverse(function (child) {
          if (child.isMesh && child.material) {
            const mat = child.material;
            materialTypes.add(mat.type);
            // 如果材质是 MeshStandard/MeshPhysical，调高 envMapIntensity 或降低 metalness
            if (mat.type === 'MeshStandardMaterial' || mat.type === 'MeshPhysicalMaterial') {
              mat.metalness = Math.min(mat.metalness, 0.1);
              mat.roughness = Math.max(mat.roughness, 0.5);
              mat.envMapIntensity = 1.0;
            }
            // 设为半透明，让 meshResult（粮面）可以透过仓房外壳可见
            mat.transparent = true;
            mat.opacity =  0.25;
            mat.depthWrite = false;
            mat.side = Three.DoubleSide;
            child.renderOrder = 5;  // 在 meshResult(renderOrder=1) 之后渲染
          }
        });
        console.log('barn.glb material types:', Array.from(materialTypes));

        // 计算模型原始边界框
        const bbox = new Three.Box3().setFromObject(model);
        const size = new Three.Vector3();
        bbox.getSize(size);
        const center = new Three.Vector3();
        bbox.getCenter(center);

        // 目标尺寸：宽(kuan) × 总高(gao+xiazhui) × 长(chang)
        const targetWidth = that.kuan;
        const targetHeight = that.gao + that.xiazhui;
        const targetDepth = that.chang;

        // 计算各轴缩放比例，整体再放大 1.2 倍
        const scaleX = targetWidth / size.x * 1.2;
        const scaleY = targetHeight / size.y * 1.2;
        const scaleZ = targetDepth / size.z * 1.2;

        model.scale.set(scaleX, scaleY, scaleZ);

        // 围绕自身Y轴旋转90°
        model.rotation.y = Math.PI / 2;

        // 定位：底部对齐 Y=0，XZ 方向居中
        model.position.set(
          -center.x * scaleX,
          -bbox.min.y * scaleY,
          -center.z * scaleZ
        );

        that.scene.add(model);
        that.barnModel = model;
        model.visible = that.checkFrame;  // 默认与仓房外框同步显示/隐藏
        console.log('barn.glb loaded:', {
          originalSize: { x: size.x, y: size.y, z: size.z },
          targetSize: { x: targetWidth, y: targetHeight, z: targetDepth },
          scale: { x: scaleX, y: scaleY, z: scaleZ },
          position: model.position
        });
      }, undefined, function (error) {
        console.error('Failed to load barn.glb:', error);
      });
    },

    // 加载异常数据
    loadErrorData(w_width, w_length) {
      if (!this.errorData) {
        console.log('没有异常数据');
        return;
      }

      let errorData = this.errorData;
      if (typeof errorData === 'string') {
        try {
          errorData = JSON.parse(errorData);
        } catch (e) {
          console.error('解析异常数据失败:', e);
          return;
        }
      }

      console.log('异常数据:', errorData);

      if (!errorData.all_anomalies || !Array.isArray(errorData.all_anomalies)) {
        console.log('异常数据格式不正确');
        return;
      }

      // 创建异常区域组
      errorAnomalies = new Three.Group();
      errorPoints = new Three.Group();

      errorData.all_anomalies.forEach((anomaly, index) => {
        // 只创建异常点云，不创建标记
        this.createAnomalyPoints(anomaly, index, w_width, w_length);
      });

      this.scene.add(errorAnomalies);
      this.scene.add(errorPoints);
    },



    // 创建异常点云
    createAnomalyPoints(anomaly, index, w_width, w_length) {
      if (!anomaly.points || anomaly.points.length === 0) {
        return;
      }

      const geometry = new Three.BufferGeometry();
      const positions = [];
      const colors = [];

      // 为每个异常区域使用不同的颜色
      const colorPalette = [
        [1, 0, 0],     // 红色
        [0, 1, 0],     // 绿色
        [0, 0, 1],     // 蓝色
        [1, 1, 0],     // 黄色
        [1, 0, 1],     // 紫色
        [0, 1, 1],     // 青色
        [1, 0.5, 0],   // 橙色
        [0.5, 0, 1],   // 紫蓝色
        [1, 0.5, 0.5], // 粉红色
        [0.5, 1, 0],   // 黄绿色
        [0, 0.5, 1],   // 天蓝色
        [1, 0, 0.5],   // 玫红色
        [0.5, 0.5, 0], // 橄榄色
        [0.5, 0, 0.5], // 深紫色
        [0, 0.5, 0.5], // 深青色
        [1, 0.8, 0.2], // 金色
        [0.8, 0.2, 1], // 紫罗兰色
        [0.2, 1, 0.8], // 春绿色
        [1, 0.2, 0.8], // 深粉色
        [0.8, 1, 0.2]  // 柠檬绿色
      ];

      // 使用索引来选择颜色，确保每个异常区域颜色不同
      const pointColor = colorPalette[index % colorPalette.length];

      anomaly.points.forEach(point => {
        if (point.length >= 3) {
          positions.push(this.chang - point[0], point[2], point[1]); // 注意坐标转换
          colors.push(pointColor[0], pointColor[1], pointColor[2]);
        }
      });

      geometry.setAttribute('position', new Three.Float32BufferAttribute(positions, 3));
      geometry.setAttribute('color', new Three.Float32BufferAttribute(colors, 3));

      // 创建点材质
      const pointMaterial = new Three.PointsMaterial({
        size: 8,
        vertexColors: true,
        transparent: true,
        opacity: 0.8
      });

      const pointCloud = new Three.Points(geometry, pointMaterial);
      pointCloud.position.set(-w_width, 0, -w_length);
      
      errorPoints.add(pointCloud);
    },

    // 监听容器尺寸变化，自动同步相机 aspect 与渲染器 size
    _setupResizeObserver(el) {
      if (!el || typeof ResizeObserver === 'undefined') return;
      if (this._resizeObserver) {
        try { this._resizeObserver.disconnect(); } catch (e) {}
      }
      this._resizeObserver = new ResizeObserver(() => {
        const w = el.clientWidth || 1;
        const h = el.clientHeight || 1;
        if (this.camera) {
          this.camera.aspect = w / h;
          this.camera.updateProjectionMatrix();
        }
        if (this.renderer) {
          this.renderer.setSize(w, h);
        }
      });
      this._resizeObserver.observe(el);
    },

  }, 
  computed: {},
  watch: {
    screenWidth() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          this.camera = null;
          this.scene = null;
          this.renderer = null;
          this.mesh = null;
          this.timer = false;
          this.init();
          this.renderScene();
        }, 1000);
      }
    },
  },
  created() {},
  mounted() {

    console.log("chang:",this.chang)
    console.log("kuan:",this.kuan)
    console.log("gao:",this.gao)

    if (this.normalizePointData(this.datas).length !== 0) {
      this.init();
      this.renderScene();
      if(this.isConsole){
        container.addEventListener( 'click', this.onDocumentMouseDown );
      }
    }
    // 使用 addEventListener 避免覆盖全局 onresize 处理（多实例/外层页面也用到时不会互相干扰）
    this._onWindowResize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    window.addEventListener('resize', this._onWindowResize);
  },
  beforeDestroy() {
    if (this._resizeObserver) {
      try { this._resizeObserver.disconnect(); } catch (e) {}
      this._resizeObserver = null;
    }
    if (this._onWindowResize) {
      window.removeEventListener('resize', this._onWindowResize);
      this._onWindowResize = null;
    }
  },
};
</script>

<style lang="scss" scoped>
#three {
  width: 100%;
  height: 100%;
  position: relative;
}

.heat-legend {
  position: absolute;
  left: 78px;
  bottom: 80px;
  z-index: 20;
  width: 118px;
  height: 180px;
  pointer-events: none;
}

.heat-legend__bar {
  position: absolute;
  left: 90px;
  top: 18px;
  width: 24px;
  height: 170px;
  border-radius: 2px;
  background: linear-gradient(
    to bottom,
    #f00000 0%,
    #ff8c00 20%,
    #ffff00 38%,
    #00f060 56%,
    #00dfff 74%,
    #003cff 100%
  );
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.18);
}

.heat-legend__label {
  position: absolute;
  right: 30px;
  color: #ffffff;
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
}

.heat-legend__label--max {
  top: 14px;
}

.heat-legend__label--min {
  bottom: -10px;
}
</style>
